import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import HeroSearchForm from "./HeroSearchForm";
import PropertyBookModal from "./PropertyBookModal";
import PropertyData from "./property-list.json";
import Icon from "@mdi/react";
import { mdiMapMarkerRadiusOutline, mdiBedKingOutline, mdiShower, mdiShieldLockOutline, mdiWifi, mdiCarSide, mdiHeartOutline, mdiHeart, mdiPool, mdiDumbbell, mdiFlower, mdiMovieOpenOutline, mdiGarage, mdiWashingMachine } from "@mdi/js";
import { AnimatePresence, motion } from "framer-motion";

// img
import heroBottomImg from "../../images/hero-bg-01.png";
import Footer from "../Layout/Footer";
import AnimatedSection from "./AnimatedSection";

export default function PropertyList() {
  const [PropertyDataList] = useState(PropertyData);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Popup
  const [showProperty, setShowProperty] = useState(false);
  const handleCloseProperty = () => setShowProperty(false);
  const handleShowProperty = () => setShowProperty(true);

  // icon fill
  const [likedDeals, setLikedDeals] = useState(
    PropertyDataList.PopularDeals.map(() => false)
  );
  const handleIconClick = (index) => {
    const updatedLikes = likedDeals.map((liked, i) =>
      i === index ? !liked : liked
    );
    setLikedDeals(updatedLikes);
  };

  // property icon
  const getIconPath = (iconName) => {
    switch (iconName) {
      case "mdiWashingMachine":
        return mdiWashingMachine;
      case "mdiGarage":
        return mdiGarage;
      case "mdiMovieOpenOutline":
        return mdiMovieOpenOutline;
      case "mdiFlower":
        return mdiFlower;
      case "mdiDumbbell":
        return mdiDumbbell;
      case "mdiPool":
        return mdiPool;
      case "mdiBedKingOutline":
        return mdiBedKingOutline;
      case "mdiShower":
        return mdiShower;
      case "mdiShieldLockOutline":
        return mdiShieldLockOutline;
      case "mdiWifi":
        return mdiWifi;
      case "mdiCarSide":
        return mdiCarSide;
      default:
        return mdiShower;
    }
  };

  const getBadgeBackgroundColor = (badgeDisplay) => {
    switch (badgeDisplay) {
      case "For Sale":
        return "#4CB6AA";
      case "Sold Out":
        return "#E34949";
      case "For Rent":
        return "#0dcaf0";
      case "coming ":
        return "#E3C814";
      case "New Listing":
        return "#212529";
      default:
        return "#212529";
    }
  };

  return (
    <>
      {/* hero section start */}
      <section className="property-list-hero">
        <Container>
          <Row className="justify-content-center mb-4">
            <Col lg={10} xl={7} className="text-center">
              <AnimatedSection>
                <h1 className="fw-bold display-5 text-shadow">
                  Explore Premium Properties Tailored for You
                </h1>
              </AnimatedSection>
              <div className="d-flex align-items-center w-50 mx-auto opacity-50">
                <i className="bi bi-star-fill fs-12 text-white opacity-85"></i>
                <div className="d-flex w-100 mx-3">
                  <hr className="border border-secondary w-50 border-1" />
                  <hr className="border border-secondary w-100 border-1 mx-2" />
                  <hr className="border border-secondary w-50 border-1" />
                </div>
                <i className="bi bi-star-fill fs-12 text-white opacity-85"></i>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="hero-bottom-img">
          <Container>
            <Row className="justify-content-center">
              <Col lg={12}>
                <img src={heroBottomImg} alt="" className="img-fluid opacity-85"/>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* hero section end */}

      <section className="section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="bg-light border border-soft-sark rounded-3 p-3 mb-5">
                <HeroSearchForm />
              </div>
            </Col>
            <Row className="justify-content-center hover-cards-container">
              {PropertyDataList.PopularDeals.map((data, i) => (
                <Col md={6} xl={4} xxl={6} key={i} className="mb-4">
                  <motion.div className="hover-card-wrapper position-relative"
                    onMouseEnter={() => setHoveredIndex(i)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    whileHover={{ scale: 1.02, y: -5 }}
                    transition={{ duration: 0.3 }}
                  >
                    <AnimatePresence>
                      {hoveredIndex === i && (
                        <motion.div
                          className="hover-overlay"
                          layoutId="hoverBackground"
                          initial={{ opacity: 0 }}
                          animate={{
                            opacity: 1,
                            transition: { duration: 0.25 },
                          }}
                          exit={{
                            opacity: 0,
                            transition: { duration: 0.2, delay: 0.1 },
                          }}
                        />
                      )}
                    </AnimatePresence>

                    {/* Property Card */}
                    <Card className="deal-card glass-effect overflow-hidden mb-0 h-100 rounded-2 shadow-sm">
                      <Card.Body className="p-4 position-relative z-2">
                        <Row className="align-items-center">
                          {/* Property Image Section */}
                          <Col xxl={6}>
                            <div className="deal-img-container position-relative rounded-2 overflow-hidden">
                              {/* Property Status Badge */}
                              <span
                                className={`sale-badge badge-glass`}
                                style={{
                                  backgroundColor: getBadgeBackgroundColor(
                                    data.badgeDisplay
                                  ),
                                  color: "#fff",
                                }}
                              >
                                {data.badgeDisplay}
                              </span>
                              <img src={require(`../../images/property-img/${data.propertyImg}`)} alt="" className="img-fluid w-100 object-fit-cover" style={{ aspectRatio: "4 / 3" }}/>
                            </div>
                          </Col>
                          {/* Property Details Section */}
                          <Col xxl={6}>
                            <div className="d-flex align-items-center justify-content-between mt-4 mt-xxl-0 mb-3">
                              <h4 className="text-primary fw-bold mb-0">
                                {data.propertyPrice}/{" "}
                                <span className="fs-14 fw-normal text-white text-opacity-75">Night</span>
                              </h4>
                              <div
                                className="text-danger heart-icon cursor-pointer"
                                onClick={() => handleIconClick(i)}
                              >
                                <Icon
                                  path={
                                    likedDeals[i] ? mdiHeart : mdiHeartOutline
                                  }
                                  className="icon-size-20"
                                />
                              </div>
                            </div>
                            {/* Property Title */}
                            <Card.Title className="fs-18 mb-2">{data.propertyTitle}</Card.Title>
                            {/* Property Location */}
                            <div className="d-flex align-items-center text-white text-opacity-85 fs-15 mb-2">
                              <Icon path={mdiMapMarkerRadiusOutline} className="icon-size-18 me-2"/> {data.homeLocation}
                            </div>
                            {/* Property Features Badges */}
                            <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                              {data.propertyFeatures.map((feature, j) => (
                                <Badge bg="light" className="text-dark fs-13 d-flex align-items-center px-2 py-1 rounded-pill" key={j}>
                                  <Icon path={getIconPath(feature.icon)} className="icon-size-16 me-2"/> {feature.value}
                                </Badge>
                              ))}
                            </div>
                            {/* View More Button */}
                            <Button variant="outline-primary" size="sm" onClick={handleShowProperty}>View More</Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Row>
          <Row>
            <Col lg={12} className="text-center">
              <div className="spinner-border text-primary mt-5" role="status"></div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <Footer />

      <PropertyBookModal showProperty={showProperty} handleCloseProperty={handleCloseProperty}/>
    </>
  );
}
